module.exports = __webpack_public_path__ + "media/edvisors/fastweb-logo-white-c99afab6.svg";